import HeaderGeneric from "../../components/generic/headerGeneric";
import { TelerikReportViewer } from "@progress/telerik-react-report-viewer";
import themeBase from "../../utils/theme/themeBase";
import { ICommandBarItemProps, PrimaryButton, Stack } from "@fluentui/react";
import TokenService from "../../services/tokenService";
import { useEffect, useRef, useState } from "react";
import { urlTelerik } from "../../services/http-common";
import AuthService from "../../services/authService";
import { keyAccess } from "../../utils/helpers/helpers";
import TablaReporte from "../../components/Table/TablaReporte";
import IconHelper from "../../utils/helpers/iconHelper";
import reporteServicio from "../../services/reporteService";
import { IExportarReporte } from "../../Interfaces/base/IBase";

let title: string = "Cuadro de Mando Checklist";
let subTitle: string = "Visualice los indicadores clave ";
let subTitle2: string = "Tome decisiones sobre el trabajo en tiempo real.";

let Parameters = {};
function MandoCheckList() {
  const urlTelerikR = `${urlTelerik}/reports`;
  let viewer;
  const reporteName = 'CMListaVerificacion.trdx'
  const _onClink = (e) => {
    // viewer.commands.export.exec("pdf")
    console.log(viewer);
  };

  let t = TokenService.getToken();
  const viewerRef = useRef();

  // useEffect(() => {
  //   EnviarToken();
  // }, [t]);

  // const EnviarToken = () => {
  //   var { viewerObject } =
  //     viewerRef.current != null ? viewerRef.current : viewerObject;
  //   viewerObject.authenticationToken(t);
  // };

  useEffect(() => {
    fetch(`${urlTelerikR}/version`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TokenService.getToken()}`,
      },
    })
      .then((response) => {
        //alert("Error telerick ...");
        //console.log("Código de estado:", response.status);
        if (response.status === 401 || response.status === 403) {
          localStorage.removeItem(keyAccess);
          AuthService.removeToken();
          window.location.assign("/login");
        }
        if (response.ok) {
          response.json().then((data) => {
            console.log("Datos de la respuesta:", data);
          });
        } else {
          console.error("Error al realizar la solicitud:", response.statusText);
        }
      })
      .catch((error) => {
        console.error("Error de red:", error);
      });
  }, []);


  //Nueva Implementación

  const viewerOptions = {
    serviceUrl: urlTelerikR,
    reportSource: {
      parameters: { editors: { multiSelect: { ...Parameters } } },
      report: reporteName,
    },
    viewerContainerStyle: themeBase.telerikStyle,
    viewMode: 'INTERACTIVE',
    // scaleMode: 'SPECIFIC',
    scaleMode: 'FIT_PAGE_WIDTH',
    scale: 1.0,
    enableAccessibility: false,
    toolbar: {
      items: [
        {
          type: 'togglePrintPreview',
          text: 'Print',
          visible: true
        },
        {
          type: 'export',
          text: 'Export',
          visible: false
        }
      ]
    },
    // ready: function () {
    //   //this.refreshReport();
    // }
  };

  const [key, setKey] = useState(0);

  // Función para recargar el componente
  const recargarComponente = () => {
    setKey(prevKey => prevKey + 1);
  };

  function descargarReporte() {
    const reporteExportar: IExportarReporte = {
      report: reporteName,
      Extension: "PDF"
    }
    reporteServicio.exportaReporte(reporteExportar)
      .then((response) => {
        if (response.status === 200) {
          // response.json().then((data) => {
          //   console.log("Datos de la respuesta:", data);
          // });
          console.log("Datos de la respuesta: Reporte generado ----");
          console.log(response.data);
          
          const dataUrl = response.data;

          // Create a link element
          const link = document.createElement('a');
          link.href = dataUrl;
          link.download = 'reporte.pdf'; // Puedes obtener el nombre del archivo de la respuesta si está disponible

          // Simulate a click on the link to trigger the download
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

        }
        else {
          console.error("Status:", response.status);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  const _items: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_RELOAD,
      onClick: recargarComponente,
    }
  ];

  const _farItems: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_PDF,
      onClick: () => {
        descargarReporte();
      },
    },
  ];

  useEffect(() => {
    const hideExportButton = () => {
      const exportButton: any = document.querySelector("#trv-main-menu-export-command");

      if (exportButton) {
        exportButton.remove();
        clearInterval(interval);
      }
    };

    // Usa un intervalo para asegurar que el botón sea encontrado y ocultado
    const interval = setInterval(hideExportButton, 1);

    // Limpia el intervalo al desmontar el componente
    return () => clearInterval(interval);
  }, [key]);

  return (
    <>
      <div
        className="ms-Grid-col ms-sm12 ms-md4 ms-lg4"
        style={{
          paddingTop: "0.5em",
        }}>
        {/* <HeaderGeneric
          title={title}
          subTitle={subTitle}
          subTitle2={subTitle2}
          enabledicon={true}
        // sizeTitles={{ first: 24, second: 11, third: 10 }}
        /> */}

        {/* /> */}
      </div>
      {/* <div>
                <PrimaryButton
                    // text="IPERC"
                    iconProps={{ iconName: 'pdf' }}
                    onClick={_onClink}
                    styles={{ root: { width: 5 } }}
                />
            </div> */}
      {/* <br /> */}
      <Stack padding={10}>
        <TablaReporte
          title={title}
          subTitle={subTitle}
          subTitle2={subTitle2}
          rigthBar={_farItems}
          leftBar={_items}
          horizontalAlign="start"
          //horizontalAlign="end"
          iconName="BarChartVerticalFill"
        />
      </Stack>


      {/* <TelerikReportViewer
        // ref={e => viewer = e}
        ref={viewerRef}
        serviceUrl={urlTelerikR}
        reportSource={{
          parameters: { editors: { multiSelect: { ...Parameters } } },
          report: "CMListaVerificacion.trdx",
        }}
        viewerContainerStyle={themeBase.telerikStyle}
        viewMode="INTERACTIVE"
        scaleMode="FIT_PAGE_WIDTH"
        scale={1.0}
      /> */}
      <div key={key}>
        <TelerikReportViewer
          ref={e => viewer = e}
          serviceUrl={viewerOptions.serviceUrl}
          reportSource={viewerOptions.reportSource}
          viewerContainerStyle={viewerOptions.viewerContainerStyle}
          viewMode={viewerOptions.viewMode}
          scaleMode={viewerOptions.scaleMode}
          scale={viewerOptions.scale}
          authenticationToken={t}
        />
      </div>
    </>
  );
}

export default MandoCheckList;
